import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { getErrorCodeForKey, TError } from "../../../../../shared/src/codecs/errors";

export const nameErrorMessage = (validationErrors: TError): string | null =>
    pipe(
        getErrorCodeForKey("edited.name", validationErrors),
        option.fold(
            (): string | null => null,
            () => "Give the introducer a name — it is shown on their partner page and identifies them in the CRM.",
        ),
    );
